import { useSelector } from "react-redux";
import { getCurrentUserRole } from "utils/currentUser.util";
import { filterNonUCHAccounts } from "utils/account.util";
import { CLINIC_ROLES } from "static/constants";

const useCheckSaasAccountUser = () => {
  const { accounts } = useSelector((state) => state.account);
  const userRole = getCurrentUserRole();

  const isClinicRole = CLINIC_ROLES.includes(userRole);

  if (!isClinicRole) {
    return false;
  }

  //WARNING: UCH Specific check.
  const filteredAccounts = filterNonUCHAccounts(accounts);

  return filteredAccounts.every((account) => account?.saas_account);
};

export default useCheckSaasAccountUser;
